import { render, staticRenderFns } from "./RoiFundTransferModal.vue?vue&type=template&id=4862994e&"
import script from "./RoiFundTransferModal.vue?vue&type=script&lang=js&"
export * from "./RoiFundTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports